import Vue from 'vue'
import Router from 'vue-router'

// LOGIN
import Login from './components/New/Login2'
import Partner from './components/New/Partner-login'

// SIGNUP
import SignUp from './components/New/SignUp2'

// SIGNUP - SUCCESS & RESEND CODE
import ResendVerificationCode from './components/New/ResendVerificationCode'

// SIGNUP - EMAIL OTP VERIFICATION
import VerifyEmailOTP from './components/New/VerifyEmailOTP'

// SIGNUP - MOBILE NUMBER VERIFICATION AND OTP VALIDATION
import MobileVerification from './components/New/mobileVerification'
import MobileOTPverfication from './components/New/validateMobileOTP'

// SIGNUP - SET PASSWORD
import SetPassword from './components/New/SetNewPassword'

// FORGOT PASSWORD
import ForgotPassword from './components/New/ForgotPassword'

// FORGOT PASSWORD - SUCCESS & RESEND LINK
import resendLink from './components/New/resendLink'

// FORGOT PASSWORD - VALIDATE LINK
import EmailVerificationForForgotPassword from './components/EmailVerificationForForgotPassword'

// FORGOT PASSWORD - RESET PASSWORD
import ResetPassword from './components/New/ResetUserPassword'

import Success from './views/Success.vue'
import EmailUpdateVerification from './components/EmailUpdateVerification'
import store from '@/store'
import document from './document/document.vue'
import taxCategoryUpdate from './components/TaxCategoryUpdate'
import AccountRecovery from './components/account-recovery.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/p/:partnerID',
      name: 'partner',
      component: Partner,
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      beforeEnter: (to, from, next) => {
        const adminOnly = store.state.ApiculusEnv.adminOnly
        if (adminOnly === true) {
          next({ path: '/' })
        }
        next()
      }
    },
    // signup - success and resend verification code
    {
      path: '/resendVerificationCode',
      name: 'resendVerificationCode',
      component: ResendVerificationCode
    },
    // signup - email otp verfication
    {
      path: '/register/:param',
      name: 'VerifyEmailOTP',
      component: VerifyEmailOTP
    },
    // signup - mobile verification
    {
      path: '/mobileVerification',
      name: 'mobileVerification',
      component: MobileVerification
    },
    // signup - verify mobile otp
    {
      path: '/mobileOTPVerification',
      name: 'mobileOTPVerification',
      component: MobileOTPverfication
    },
    // signup - set password
    {
      path: '/setPassword',
      name: 'SetNewPassword',
      component: SetPassword,
      // beforeEnter: (to, from, next) => {
      //   if (store.state.ApiculusEnv.mobileRequired && to.params.emailVerified && to.params.mobileVerified) {
      //     next()
      //   } else if (to.params.emailVerified) {
      //     next()
      //   } else {
      //     next({ path: '/signup' })
      //   }
      // }
    },
    // forgot password
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    // forgot password - success and resend link
    {
      path: '/resendLink',
      name: 'resendLink',
      component: resendLink
    },
    // forgot password - verify link
    {
      path: '/forgotPassword/:param',
      name: 'EmailVerificationForForgotPassword',
      component: EmailVerificationForForgotPassword
    },
    // forgot password - reset password
    {
      path: '/resetPassword',
      name: 'ResetUserPassword',
      component: ResetPassword
    },
    {
      path: '/account-locked',
      name: 'login',
      component: Login
    },
    {
      path: '/password-expired',
      name: 'login',
      component: Login
    },
    {
      path: '/recover-account',
      name: 'AccountRecovery',
      component: AccountRecovery
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    // ott login
    {
      path: '/redirectionVerification',
      name: 'login',
      component: Login
    },
    {
      path: '/document',
      name: 'Documents',
      component: document
    },
    // primary email updation
    {
      path: '/process/:param',
      name: 'emailUpdateVerification',
      component: EmailUpdateVerification
    },
    {
      path: '/taxCategoryUpdateVerification',
      name: 'taxCategoryUpdate',
      component: taxCategoryUpdate
    }
  ]
})
